export const LOAD_LEVEL = "LOAD_LEVEL";
export const CLOSE_LEVEL = "CLOSE_LEVEL";
export const COMPLETE_LEVEL = "COMPLETE_LEVEL";
export const RESTART_LEVEL = "RESTART_LEVEL";



// WEBPACK FOOTER //
// ./src/actionCreators/levelActionNames.js